import type { HttpGet } from '@/shared/infra/http'
import type { ChannelMember, ListChannelMembers } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'

type ChannelMemberDto = {
  userId: string
  name?: string | null
}

type ListChannelMembersResponseDto = {
  members?: ChannelMemberDto[] | null
}

function toChannelMember(dto: ChannelMemberDto): ChannelMember {
  return {
    userId: dto.userId,
    name: dto.name ?? 'Member',
  }
}

export class EdgeListChannelMembersRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListChannelMembers = async (params) => {
    const query = `?orgId=${encodeURIComponent(params.orgId)}&orgType=${params.orgType}`
    try {
      const data = await this.http.get<ListChannelMembersResponseDto>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}/members${query}`,
      })
      return {
        members: (data?.members ?? []).map(toChannelMember),
      }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
